import { render, staticRenderFns } from "./VersionsTabs.vue?vue&type=template&id=b7c0b8dc"
import script from "./VersionsTabs.vue?vue&type=script&lang=js"
export * from "./VersionsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports